import { render, staticRenderFns } from "./PostingListItem.vue?vue&type=template&id=6cfe258b&scoped=true&"
import script from "./PostingListItem.vue?vue&type=script&lang=js&"
export * from "./PostingListItem.vue?vue&type=script&lang=js&"
import style0 from "./PostingListItem.vue?vue&type=style&index=0&id=6cfe258b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe258b",
  null
  
)

export default component.exports